
import { createModel } from '@rematch/core'

const initialState: { showSpinner:  boolean  } = {
   
    showSpinner: false, 
}


export const spinnerModel = createModel()({
    state: { ...initialState },
    reducers: {

        setSpinner(state, payload) {
            return {
                ...state,
                showSpinner: payload
            }
        },
    },
   

})